import axios from "axios";
// List products with Api
export const GetQuestionById = async (question_id,languaje,jwt,user_id) => {

  let url = process.env.REACT_APP_ADMIN_API_URL + `/questionById`
  let data = "";
  let qs = require('qs');
  data = qs.stringify({
    'question_id': question_id,
    'language_id': languaje,
    'user_id': user_id
  });
  try {
    const response = await axios.post(
        url,
        data,
      {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};